/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_FromInputs */

const es_chat_tool_detail_from = /** @type {(inputs: Chat_Tool_Detail_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De`)
};

const en_chat_tool_detail_from = /** @type {(inputs: Chat_Tool_Detail_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Chat_Tool_Detail_FromInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_from = /** @type {((inputs?: Chat_Tool_Detail_FromInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_FromInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_from(inputs)
	return en_chat_tool_detail_from(inputs)
});
export { chat_tool_detail_from as "chat.tool_detail.from" }